import { values, head, pathOr, cond, equals, always, T } from 'ramda';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'src/store/ApplicationState';
import {
  BORROWER,
  REDUX_BORROWERS,
  REDUX_EMPLOYMENTS,
  EMPLOYMENT,
  PROPERTY,
  DECLARATION,
  REDUX_DECLARATIONS,
  LENDINGTERMS,
  REDUX_LOANAPP,
  REDUX_BUSINESS,
  LOANAPP_ACCOUNT,
  LOAN_STATUS,
  TEAM_MEMBER,
  REDUX_ACCOUNTS,
  REDUX_PROPERTY,
  ITEMS_BY_ID,
  USER_REDUX_RESOURCE_NAME,
  DATA,
  REDUX_LENDING_TERMS,
  REDUX_TEAM_MEMBERS,
  REDUX_LOAN_STATUS
} from "src/store/constants";

import {
  getAccountByActiveLoanRole,
  getActiveBorrowerAccount,
  getItemsByIdResourcesWithActiveLoanRole
} from "src/store/store.helpers";

export const getApiResourceDetails = (resource: any) => {
  const resources = useSelector((state: ApplicationState) => {
    return state;
  });
  const applicantAccounts = getActiveBorrowerAccount(resources);
  const borrower = head(getItemsByIdResourcesWithActiveLoanRole(
    REDUX_BORROWERS,
    resources));
  const appAccount = getAccountByActiveLoanRole(resources)
  const employment = getItemsByIdResourcesWithActiveLoanRole(
    REDUX_EMPLOYMENTS,
    resources)
  const property = head(values(pathOr({}, [USER_REDUX_RESOURCE_NAME, REDUX_PROPERTY, ITEMS_BY_ID], resources)));
  const declarations = head(
    getItemsByIdResourcesWithActiveLoanRole(
      REDUX_DECLARATIONS,
      resources))
  const lending_terms = head(
    getItemsByIdResourcesWithActiveLoanRole(
      REDUX_LENDING_TERMS,
      resources));
  const loanApp = pathOr({}, [USER_REDUX_RESOURCE_NAME, REDUX_LOANAPP, DATA], resources);
  const business = head(pathOr([], [USER_REDUX_RESOURCE_NAME, REDUX_LOANAPP, DATA, 'spec', 'business'], resources));
  const loanStatus = head(pathOr([], [USER_REDUX_RESOURCE_NAME, REDUX_LOAN_STATUS, DATA, 'items'], resources));
  const teamMembers = values(pathOr([], [USER_REDUX_RESOURCE_NAME, REDUX_TEAM_MEMBERS, ITEMS_BY_ID], resources));

  return cond([
    [
      equals(BORROWER),
      always(borrower),
    ],
    [
      equals(REDUX_ACCOUNTS),
      always(applicantAccounts),
    ],
    [
      equals(EMPLOYMENT),
      always(employment),
    ],
    [
      equals(PROPERTY),
      always(property)
    ],
    [
      equals(DECLARATION),
      always(declarations)
    ],
    [
      equals(LENDINGTERMS),
      always(lending_terms)
    ],
    [
      equals(REDUX_LOANAPP),
      always(loanApp)
    ],
    [
      equals(REDUX_BUSINESS),
      always(business)
    ],
    [
      equals(LOANAPP_ACCOUNT),
      always(appAccount)
    ],
    [
      equals(LOAN_STATUS),
      always(loanStatus)
    ],
    [
      equals(TEAM_MEMBER),
      always(teamMembers)
    ],
    [T, always('')]
  ])(resource)
}
